import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import Autoplay from "%/dynamic-component-editor/options/autoplay";
import Controls from "%/dynamic-component-editor/options/controls";
import Muted from "%/dynamic-component-editor/options/muted";
import MuteOnAutoplay from "%/dynamic-component-editor/options/mute-on-autoplay";
import Poster from "%/dynamic-component-editor/options/poster";
import SingleVideo from "%/dynamic-component-editor/options/single-video";
import Loop from "%/dynamic-component-editor/options/loop";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class VideoOptions extends BaseOptionsBundle {

  optionTitle = "Video";
  static optionClassName = "i-dynamic-video";
  inspectorToolGroup = "video";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.VIDEO_TOOLSET,
  };

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new SingleVideo(null, hideFromInspector["single-video"] ?? false),
      Autoplay,
      Controls,
      Loop,
      Muted,
      MuteOnAutoplay,
      Poster,
    ]);
  }
}
